export const AclSubjects = {
  ALL: "all",
  HOME: "home",
  CATEGORIES:"categories",
  SUPPORT: "SUPPORT",
  PROVIDERS: "PROVIDERS",
  BIDDING: "BIDDING",
  REFUNDS: "REFUNDS",
  RELESTATE: "RELESTATE",
  SHOWROOMS_CARS: "SHOWROOMS_CARS",
  SHOWROOMS_REALESTATE: "SHOWROOMS_REALESTATE",
  SHOWROOMS_JELWERY: "SHOWROOMS_JELWERY",
  MESSAGES: "MESSAGES",
  SOUQ: "SOUQ",
  AGENCECARS: "AGENCECARS",
  AUCTIONS: "AUCTIONS",
  BIDS: "BIDS",
  DESPITE: "DESPITE",
  TICKETS: "TICKETS",
  STUFFS: "STUFFS",
  OWNERS: "OWNERS",
  CUSTOMERS: "CUSTOMERS",
  MARKETING: "MARKETING",
  NOTIFICATIONS: "NOTIFICATIONS",
  SETTINGS: "settings",
  APP_SETTINGS: "app_settings",
  SESSIONS: "sessions",
  
}
export const AclActions = {
  MANAGE: "manage",
  PUBLISH: "PUBLISH",
  READ: "read",
  UPDATE: "update",
  CREATE: "create",
  DELETE: "delete",
  VIEW_DELETED: "VIEW_DELETED",
  UPDATE_DRAFT: "UPDATE_DRAFT",
  CAN_TAKE: "CAN_TAKE",
  CAN_REVIEW: "CAN_REVIEW",
  CAN_VIEW_UPDATED_BY: "CAN_VIEW_UPDATED_BY",
  CAN_VIEW_UPDATED_AT: "CAN_VIEW_UPDATED_AT",
  CAN_VIEW_PUBLISHED_AT: "CAN_VIEW_PUBLISHED_AT",
  CAN_CONFIRM: "CAN_CONFIRM",
  CAN_FILTER_DATAENTRY: "CAN_FILTER_DATAENTRY",
  CAN_FILTER_REFRENCE: "CAN_FILTER_REFRENCE",
  CAN_REJECT: "CAN_REJECT",
  CAN_CHECKEDAR: "CAN_CHECKEDAR",
  CAN_CHECKEDEN: "CAN_CHECKEDEN",
  VIEW_DATAENTRY: "VIEW_DATAENTRY",
  VIEW_CONTRACT: "VIEW_CONTRACT",
  UPDATE_PENDING: "UPDATE_PENDING",
  UPDATE_REJECTED: "UPDATE_REJECTED",
  UPDATE_CHECKEDAR: "UPDATE_CHECKEDAR",
  UPDATE_CHECKEDEN: "UPDATE_CHECKEDEN",
  UPDATE_INREVIEW: "UPDATE_INREVIEW",
  UPDATE_INCHECKENG: "UPDATE_INCHECKENG",
  UPDATE_TAKEN: "UPDATE_TAKEN",
  UPDATE_CONFIRMED: "UPDATE_CONFIRMED",
  UPDATE_INCHECKAR: "UPDATE_INCHECKAR",
  UPDATE_PUBLSIHED: "UPDATE_PUBLSIHED",
  VIEW_TAKEN: "VIEW_TAKEN",
  VIEW_DRAFT: "VIEW_DRAFT",
  VIEW_PENDING: "VIEW_PENDING",
  VIEW_INREVIEW: "VIEW_INREVIEW",
  EDIT_ASSETS: "EDIT_ASSETS",
  VIEW_CONFIRMED: "VIEW_CONFIRMED",
  VIEW_INCHECKENG: "VIEW_INCHECKENG",
  VIEW_INCHECKAR: "VIEW_INCHECKAR",
  VIEW_REJECTED: "VIEW_REJECTED",
  VIEW_EXPIRED: "VIEW_EXPIRED",
  VIEW_CHECKEDAR: "VIEW_CHECKEDAR",
  VIEW_PUBLSIHED: "VIEW_PUBLSIHED",
  VIEW_HISTORY: "VIEW_HISTORY"
}
